interface TimelineEvent {
  id: string | number
  icon: React.ReactNode
  title: string
  description?: string
  time: string
  color: 'success' | 'info' | 'warning' | 'danger' | 'primary'
}

interface ActivityTimelineProps {
  events: TimelineEvent[]
}

export default function ActivityTimeline({ events }: ActivityTimelineProps) {
  if (events.length === 0) return null

  return (
    <div className="activity-timeline">
      {events.map((event) => (
        <div key={event.id} className="timeline-event">
          <div className={`timeline-dot timeline-dot--${event.color}`}>
            {event.icon}
          </div>
          <div className="timeline-event__content">
            <div className="timeline-event__header">
              <span className="timeline-event__title">{event.title}</span>
              <span className="timeline-event__time">{event.time}</span>
            </div>
            {event.description && (
              <p className="timeline-event__desc">{event.description}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
